import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ApiRequestService, DialogService, FilterPipe, MAT_ICON, TOAST_STATE, ToastmessageService, TranslationPipe, TranslationService } from '@prekog/common-ui';
import { Observable, switchMap, tap } from 'rxjs';
import { UploadFileResponse } from '../../products/product-form/use-cases/update-product/upload-file.response';
import { Material } from '../../products/product-list/material.model';
import { UploadToAnExistingFolderRequest } from '../../products/upload-to-an-existing-folder.request';
import { UploadToAnExistingFolderResponse } from '../../products/upload-to-an-existing-folder.response';
import { AddpackagepriceDialogComponent } from '../addpackage/addpackagepricedialog/addpackagepricedialog.component';
import { AddPackagepriceDialogResult } from '../addpackage/addpackagepricedialog/addpackagepricedialogresult';
import { AddPackagePriceRequest } from '../addpackage/addpackagepricedialog/addpackagepricerequest';
import { PackageWithProductMapping } from '../addpackage/packagewithproductmapping';
import { Package } from '../package';
import { PackageProduct } from '../packageproduct';
import { GetPackageRequest } from './getpackagerequest';
import { GetPackageWithProductsRequest } from './getpackagewithproductsrequest';
import { GetPackageWithProductsResponse } from './getpackagewithproductsresponse';
import { UpdatePackageRequest } from './updatepackagerequest';

@Component({
    selector: 'app-updatepackage',
    templateUrl: './updatepackage.component.html',
    styleUrls: ['./updatepackage.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, FormsModule, MatIconModule, CommonModule, DragDropModule, FilterPipe, TranslationPipe]
})
export class UpdatepackageComponent implements OnInit {
    downloadUri = '';
    fileBaseUrl = '';
    fileCover: File | null = null;
    @ViewChild('fileCoverInput') fileCoverInput: ElementRef | undefined;
    filteredBooks: Material[] = [];
    getPackageRequest: GetPackageRequest = {};
    getPackageWithProductsUrl = '/admin/getPackageWithProducts';
    maxFileSize = 5000000;
    package: Package = {};
    packageForm?: FormGroup;
    productsExcludingPackage: Material[] = [];
    searchText = '';
    storeBaseUrl = '';
    storeExistingProductsURI = '/store/get-products';
    sum = 0;
    updateableProducts: Material[] = [];
    updateCoverFile = false;
    updatePackageRequest: UpdatePackageRequest = {};
    updatePackageUrl = '/admin/updatepackage';
    uploadFileResponse: UploadFileResponse = {};
    uploadFileToAnExistingFolderRequest: UploadToAnExistingFolderRequest = {};
    uploadFileToAnExistingFolderResponse: UploadToAnExistingFolderResponse = {};
    uploadFileToAnExistingFolderUrl = '/admin/updatefile';
    uploadFileUrl = '/admin/uploadFile';
    addPackagePriceUrl = '/admin/add-package-price';
    url = '';

    private _dialogService = inject(DialogService);

    constructor(
        private _fb: FormBuilder,
        private _toastMessageService: ToastmessageService,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _translateService: TranslationService
    ) {
        this.storeBaseUrl = _storeBaseUrl;
        this.fileBaseUrl = _fileManagerUrl;
        this.createPPackageForm();
    }

    addProductToPackage(product: Material) {
        this.sum += product.packagePrice!;
        if (!product.packagePrice) {
            this.openAddPackagePriceDialog(product);
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('Kérem adja meg a csomagárat a ' + product.author + ':' + product.title + ' könyvhöz!'),
                MAT_ICON.error
            );
            this.dismissErrorFiveSeconds();
        } else {
            const index = this.productsExcludingPackage.indexOf(product);
            this.productsExcludingPackage.splice(index, 1);
            this.updateableProducts.push(product);
        }
    }

    openAddPackagePriceDialog(product: Material) {
        this._dialogService.openDialog(
            AddpackagepriceDialogComponent,
            null,
            ((addPackagepriceDialogResult: AddPackagepriceDialogResult | undefined) => {
                this.addPackagePrice(product, addPackagepriceDialogResult?.packagePrice!);

            }
            )
        );
    }

    addPackagePrice(product: Material, packagePrice: number) {
        const addPackagePriceRequest: AddPackagePriceRequest = {
            packagePrice: packagePrice,
            productId: product.id
        };

        this._apiRequestService
            .sendRequest<
                AddPackagePriceRequest,
                HttpResponse<any>
            >(this.storeBaseUrl, addPackagePriceRequest, true, this.addPackagePriceUrl, true)
            .subscribe(() => {
                const index = this.productsExcludingPackage.indexOf(product);
                this.productsExcludingPackage.splice(index, 1);
                this.updateableProducts.push(product);
            });
    }

    deleteFromPackageProductList(product: Material) {
        this.sum -= product.packagePrice!;
        const index = this.updateableProducts.indexOf(product);
        this.updateableProducts.splice(index, 1);
        this.productsExcludingPackage.push(product);
    }

    //TODO combine it with Products changing option!
    ngOnInit(): void {
        const lastSegmentOfUrl = window.location.href.split('/').pop();
        const routerLink = lastSegmentOfUrl as string;

        const getPackageWithProductsRequest: GetPackageWithProductsRequest = {
            routerLink: routerLink
        };

        this._apiRequestService
            .sendRequest<
                GetPackageWithProductsRequest,
                GetPackageWithProductsResponse
            >(this.storeBaseUrl, getPackageWithProductsRequest, true, this.getPackageWithProductsUrl)
            .subscribe((response) => {
                this.package = response.packageDTO as Package;
                this.updateableProducts = response.packageProducts as Material[];
                this.productsExcludingPackage = response.productsExcludingPackage!;
                this.filteredBooks = this.productsExcludingPackage;
                this.updateableProducts.forEach((updatableProduct) => {
                    this.sum += updatableProduct.packagePrice!;
                });
            });
    }

    onChange(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileCover = target.files![0];
        if (this.fileCover.name.split('.').pop() === 'png') {
            this.updateCoverFile = true;
        } else {
            this.updateCoverFile = false;
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.warning,
                'Kérem ".png" kiterjesztésű fájlt töltsön fel!',
                MAT_ICON.warning
            );
            this.dismissError();
        }
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    private dismissErrorFiveSeconds(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }

    createPPackageForm() {
        this.packageForm = this._fb.group({
            packageName: ['', [Validators.required]]
        });
    }

    collectPackageData() {
        this.package.packageName = this.packageForm?.controls['packageName'].value as string | undefined;

        if (this.url) {
            this.package.imageUrl = this.url;
        }
    }

    clearSelectedCoverFile() {
        if (this.fileCoverInput) {
            (this.fileCoverInput.nativeElement as HTMLInputElement).value = '';
            this.updateCoverFile = false;
        }
    }

    drop(event: CdkDragDrop<PackageProduct[]>): void {
        moveItemInArray(this.updateableProducts, event.previousIndex, event.currentIndex);
    }

    handleUpdatePackage() {
        if (this.fileCover && this.fileCover.size > this.maxFileSize) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('A maximum fájl korlát 5MB. Kérem ennél kisebb méretű fájlt töltsön fel!'),
                MAT_ICON.error
            );
            this.dismissError();
            return;
        }

        let updateChain: Observable<HttpResponse<any>>;

        const hasFileToUpload = this.fileCover !== null && this.fileCover.size > 0;

        if (hasFileToUpload) {
            updateChain = this._updateFileObservable().pipe(switchMap(() => this._updatePackageObservable()));
        } else {
            updateChain = this._updatePackageObservable();
        }

        updateChain.subscribe();
    }

    private _updatePackageObservable(): Observable<HttpResponse<any>> {
        this.collectPackageData();

        const packageProductList: PackageProduct[] = [];
        this.updateableProducts.forEach((productsToPackage, index) => {
            const packageProduct: PackageProduct = new PackageProduct();
            packageProduct.product = productsToPackage;
            packageProduct.packageObject = this.package;
            packageProduct.orderNumber = index;
            packageProductList.push(packageProduct);
        });

        const packageWithProductMapping: PackageWithProductMapping = {
            packageDTO: this.package,
            packageProductList: packageProductList
        };

        this.updatePackageRequest = {
            packageWithProductMappings: packageWithProductMapping
        };

        return this._apiRequestService.sendRequest<UpdatePackageRequest, HttpResponse<any>>(
            this.storeBaseUrl,
            this.updatePackageRequest,
            true,
            this.updatePackageUrl,
            true
        );
    }

    private _updateFileObservable(): Observable<any> {
        const folderName = this.package.imageUrl?.split('/').pop() as string;

        return this._apiRequestService
            .updateFile(this.fileCover!, folderName, true, this.fileBaseUrl, this.uploadFileToAnExistingFolderUrl)
            .pipe(
                tap((response) => {
                    const uploadFileResponse = response as UploadFileResponse;
                    if (uploadFileResponse.downloadUri) {
                        this.url = uploadFileResponse.downloadUri;
                        this.updateCoverFile = false;
                    }
                })
            );
    }
}
